import React, { useState } from 'react'
import s from './referral-table.module.scss'
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import ReactPaginate from 'react-paginate';
import { useMedia } from 'use-media';
import { FetchingDiv } from '@shared/ui/fetching-div/fetching-div';
import { TableReferralCard } from '../table-referral-card/table-referral-card';
import { useReferrals } from '@widgets/referrals/api/useReferrals';

export const ReferralTable = () => {
	const [page, setPage] = useState(0)
	const {data: referrals, isFetched } = useReferrals(page)


	const isMobile = useMedia({maxWidth: '768px'})
	
	return (
		<FetchingDiv className={s.wrapper} isFetching={!isFetched}>
			{referrals?.total > 0 ? 
			<div className={s.flex}>
				<table cellSpacing="0" cellPadding="0">
					{isMobile ? 
						<></>
					:
					<thead>
						<tr>
							<th>
								<div className={s.th}>
									Дата записи
									{/* <button>
										<IconSortAscending size={18}/>
									</button> */}
								</div>
							</th>
							<th>
								<div className={s.th}>
									Преподаватель
									{/* <button>
										<IconSortAscending size={18}/>
									</button> */}
								</div>
							</th>
							<th>
								<div className={s.th}>
									Статус
								</div>
							</th>
						</tr>
					</thead>
					}
					<tbody>
						{referrals?.data?.map((referral, index) => (
							<TableReferralCard referral={referral} key={index} />
						))}
					</tbody>
				</table>
				<ReactPaginate
					breakLabel="..."
					forcePage={page}
					nextLabel={<IconChevronRight size={12}/>}
					onPageChange={(e) => setPage(e.selected )}
					pageRangeDisplayed={5}
					pageCount={referrals?.total/referrals?.per_page}
					previousLabel={<IconChevronLeft size={12}/>}
					className={s.paginator}
					previousClassName={s.prev}
					nextClassName={s.next}
					disabledClassName={s.disabled}
					pageLinkClassName={s.item}
					activeLinkClassName={s.active}
				/>
			</div> : <div className={s.empty}>У вас пока нет рефералов</div>
			}
		</FetchingDiv>
	)
}